import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { MatTableModule } from '@angular/material/table';
import { MainService } from 'src/app/services/delavci/main.service';
import { Router } from '@angular/router';
import { HelpersService } from 'src/app/services/shared/helpers.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { HelpdeskService } from 'src/app/services/delavci/helpdesk.service';
import { WarehouseAppService } from 'src/app/services/warehouse-app.service';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { NgxScannerQrcodeComponent, NgxScannerQrcodeService } from 'ngx-scanner-qrcode';

export interface ScanElement {
  type: string;
  id: number;
  code: string;
  nameSmall: string;
  status: string;
  partner: string;
  documentDate: string;
}

const ELEMENT_DATA: ScanElement[] = [
  //{type: "ITEM", id: 1, code: "TEST", nameSmall: "Test", status: "ACTIVE", partner: "Test", documentDate: '2021-01-01'},

];

@Component({
  selector: 'app-aplikacija-home',
  templateUrl: './aplikacija-home.component.html',
  styleUrls: ['./aplikacija-home.component.css']
})


export class AplikacijaHomeComponent implements AfterViewInit {
  displayedColumns: string[] = ['type', 'id', 'code', 'nameSmall', 'status', 'partner', 'documentDate'];
  dataSource = ELEMENT_DATA;
  isVisible: boolean = false;
  @ViewChild('action') scanner: NgxScannerQrcodeComponent;
  scanInput: string = '';
  scanResult: any = null;
  documents: any[] = [];

  ngAfterViewInit() {
    this.scanner.data.subscribe(result => {
      if (result && result.length > 0) {
        console.log('Scan data:', result);
        if (result[0].value) {
          this.scanInput = result[0].value;  // Update the input field with scan result
          this.stopScanner();  // Optionally stop the scanner
        }
      }
    });
  }

  constructor(private mainService: MainService, private router: Router, private helpersService: HelpersService,
    private deviceService: DeviceDetectorService, private helpdeskService: HelpdeskService,
    private warehouseAppService: WarehouseAppService, private snackBar: MatSnackBar, private qrcode: NgxScannerQrcodeService) {
  }

  searchByScan(id: string) {
    this.warehouseAppService.mobileSearchScan(id).subscribe(
      (data) => {
        console.log("Data received:");
        if (data.documents.length === 1) {
          console.log(data.documents[0]);
          console.log("Redirecting to aplikacija-home-documents...");
          this.router.navigate(['aplikacija-home-documents'], { state: { documents: data.documents } });
        } else if (data.documents.length > 1) {
          this.documents = data.documents;  // Store the documents data
          console.log(data.documents);
        } else {
          this.snackBar.open('Artikel ne obstaja', '', {
            duration: 3000,
          });
          console.log("There are no items");
        }
      },
      (error) => {
        console.error("Error occurred while fetching data:", error);
      }
    );
  }

  toggleVisibilityAndScanner() {
    this.isVisible = !this.isVisible;
    if (this.isVisible) {
      this.scanner.start();
    } else {
      this.stopScanner();
    }
  }

  stopScanner() {
    this.scanner.stop();
    this.isVisible = false;
  }

  ChooseDocument(id: number) {
    const selectedDocument = this.documents.find(doc => doc.id === id);
    if (selectedDocument) {
      this.router.navigate(['aplikacija-home-documents'], { state: { documents: [selectedDocument] } });
    }
  }
  
}
